// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ_IN_STOCK = "Skladem";
